import { BrowserRouter as Router } from "react-router-dom";
import { AppProviders } from "@/components/providers/AppProviders";
import { AppLayout } from "@/components/layout/AppLayout";

const App: React.FC = () => {
  return (
    <Router>
      <AppProviders>
        <AppLayout />
      </AppProviders>
    </Router>
  );
};

export default App;
